import React from 'react'
const InfoPopUp = (props) => {
    return ( 
        <ul>
            <li>The insured was extremely inquisitive about the Claim Process.</li>
            <li>Although the stated income in the Proposal form is “x” but during my visit I found standard of living contrary to the lifestyle declared in the proposal.</li>
            <li>Suspicious third party accompanying customers.</li>
            <li>Customer dominating the discussions on buying insurance.</li>
            <li>Customer entering into transactions that do not make commercial sense</li>
            <li>The Proposer was not keen in allowing me to meet the L2BI.</li>
        </ul>
     );
}
 
export default InfoPopUp;











